"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var SmokeLayerToggle = function (_a) {
    var isVisible = _a.isVisible, currentTime = _a.currentTime, onClick = _a.onClick;
    var getCheckboxIcon = function () {
        return isVisible
            ? React.createElement("span", { className: "icon-ui-checkbox-checked" })
            : React.createElement("span", { className: "icon-ui-checkbox-unchecked" });
    };
    var getLabel = function () {
        var forcastTime = currentTime && isVisible
            ? React.createElement("span", { className: 'margin-left-half' },
                "(",
                date_fns_1.format(new Date(currentTime), 'MMMM do, p'),
                ")")
            : null;
        return React.createElement("span", null,
            "Smoke forecast",
            forcastTime);
    };
    return (React.createElement("div", { className: 'cursor-pointer font-size--3', style: {
            'padding': '.35rem 0'
        }, onClick: onClick },
        getCheckboxIcon(),
        getLabel()));
};
exports.default = SmokeLayerToggle;
